<mat-drawer-container class="sidenavContainer">
  <!-- @if (userService.isLoggedIn()) { -->
  <mat-drawer [mode]="navbarService.sidenavMode()" [opened]="navbarService.sidenavOpened()"
    (closed)="navbarService.isExpanded.set(false)">
    <div class="drawerContent">
      <div class="sidenavContent">
        <div class="logo">
          <lib-logo-with-badge
            [src]="'./shared-assets/icons/awo-care-logo.svg'"
            [alt]="'AWO-Care Icon'"
            [logoClass]="'loginIcons'"
            [tier]="environmentTier"
          />
        </div>

        @for (group of visibleGroups(); track $index) {
          <div class="nav-group" [class.separated]="group.separated" role="group"
            [attr.aria-label]="group.title ?? null">
            @if (group.title) {
              <div class="group-title">{{ group.title }}</div>
            }
            @for (entry of group.entries; track entry.path) {
              <a [routerLink]="'/' + entry.path" [class.active]="isActive(entry)"
                [attr.aria-current]="isActive(entry) ? 'page' : null"
                [attr.aria-label]="entryLabel(entry)"
                [title]="entry.label" (click)="navbarService.closeSidenavOnMobile()">
                <mat-icon>{{ entry.icon }}</mat-icon>
                {{ entry.label }}
                @if (entry.badge) {
                  <app-count-badge [count]="badgeValue(entry.badge.key)" [tone]="entry.badge.tone" />
                }
              </a>
            }
          </div>
        }
      </div>
      <div class="bottomSection">
        <div class="footer-row">
        <a class="profile-tile" routerLink="/settings/profile" [class.active]="profileActive()"
          title="Profil öffnen" (click)="navbarService.closeSidenavOnMobile()">
          <span class="avatar" aria-hidden="true">{{ profileTile().initials }}</span>
          <span class="who">
            <span class="name">{{ profileTile().name }}</span>
            <span class="role">{{ profileTile().roleLabel }}</span>
          </span>
        </a>
        @if (ticketPortal.enabled) {
          <!-- „Frage stellen“ (#1175): öffnet das Feedback-Widget; Zahl = ungelesene Antworten. -->
          <button type="button" class="help-button" title="Frage stellen"
            [attr.aria-label]="ticketPortal.unreadCount() > 0 ? 'Frage stellen, ' + ticketPortal.unreadCount() + ' ungelesen' : 'Frage stellen'"
            (click)="openSupport()">
            ?
            @if (ticketPortal.unreadCount() > 0) {
              <span class="help-badge" aria-hidden="true">{{ ticketPortal.unreadCount() }}</span>
            }
          </button>
        }
        </div>
        <button type="button" class="version" (click)="openVersionDialog()" title="Version anzeigen">
          v{{ currentVersion }}
        </button>
      </div>
    </div>
  </mat-drawer>
  <!-- } -->
  <mat-drawer-content>
    <!-- @if (userService.isLoggedIn()) { -->
    <mat-toolbar class="toolbar">
      <button mat-icon-button (click)="navbarService.toggleSidenav()" aria-label="Toggle sidenav">
        <mat-icon>menu</mat-icon>
      </button>
      @if (navbarService.breadcrumbs().length > 1) {
        <nav class="breadcrumbs">
          @for (crumb of navbarService.breadcrumbs(); track crumb.url; let last = $last) {
            @if (!last) {
              <a [routerLink]="crumb.url" class="breadcrumb-link">{{ crumb.label }}</a>
              <mat-icon class="breadcrumb-separator">chevron_right</mat-icon>
            } @else {
              <span class="breadcrumb-current">{{ crumb.label }}</span>
            }
          }
        </nav>
      } @else {
        <span class="toolbar-title">{{ navbarService.navbarTitle() }}</span>
      }
      <span class="spacer"></span>
      <lib-feedback-button />
    </mat-toolbar>
    @if (userService.simulatedRole()) {
      <div class="role-simulation-banner" role="status">
        <mat-icon>visibility</mat-icon>
        <span>
          <strong>Ansicht als {{ simulatedRoleLabel() }}</strong> — nur die Oberfläche
          ändert sich. Daten und Aktionen laufen weiter mit deinen Admin-Rechten.
        </span>
        <button mat-flat-button (click)="stopRoleSimulation()">Beenden</button>
      </div>
    }
    <!-- } -->
    <ng-content> </ng-content>
  </mat-drawer-content>
</mat-drawer-container>